<template>
  <div class="market-contracts-stats">
    <div class="market-contracts-stats__market-name" v-if="isLayoutDesktop">
      {{ market.marketName }}
    </div>
    <table class="market-contracts-stats__table">
      <thead class="market-contracts-stats__thead">
        <th
          class="market-contracts-stats__table-name"
          @click="sortBy('displayOrder')"
          v-if="isSortable"
        >
          <span :class="headerSortByModifiers('displayOrder')"> Contract </span>
        </th>
        <th @click="sortBy('totalSharesTraded')" :class="secondColumnModifiers">
          <span :class="headerSortByModifiers('totalSharesTraded')"> Total Volume </span>
        </th>
        <template v-if="!isMarketSettled">
          <th @click="sortBy('todaysVolume')" :class="thirdColumnModifiers">
            <span :class="headerSortByModifiers('todaysVolume')"> Today's Volume </span>
          </th>
          <th
            v-if="isLayoutDesktop"
            @click="sortBy('openInterest')"
            class="market-contracts-stats--last"
          >
            <span :class="headerSortByModifiers('openInterest')"> Active Shares </span>
          </th>
        </template>
      </thead>
      <tbody>
        <tr v-for="(item, index) in sortedItems" :key="index">
          <td class="market-contracts-stats__table-name" v-if="isSortable">
            {{ item.contractName }}
          </td>
          <td :class="secondColumnModifiers">
            {{ item.totalSharesTraded.toLocaleString() }}
          </td>
          <template v-if="!isMarketSettled">
            <td :class="thirdColumnModifiers">
              {{ item.todaysVolume.toLocaleString() }}
            </td>
            <td v-if="isLayoutDesktop" class="market-contracts-stats--last">
              {{ item.openInterest.toLocaleString() }}
            </td>
          </template>
        </tr>
        <tr v-if="isSortable">
          <td
            class="market-contracts-stats__table-name market-contracts-stats__table-name--bold market-contracts-stats__table-summary"
          >
            Total
          </td>
          <td class="market-contracts-stats__table-summary" :class="secondColumnModifiers">
            {{ totalSharesTradedSum }}
          </td>
          <template v-if="!isMarketSettled">
            <td class="market-contracts-stats__table-summary" :class="thirdColumnModifiers">
              {{ todaysVolumeSum }}
            </td>
            <td
              v-if="isLayoutDesktop"
              class="market-contracts-stats__table-summary market-contracts-stats--last"
            >
              {{ openInterestSum }}
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script src="./market-contracts-stats.js"></script>
<style src="./market-contracts-stats.scss" lang="scss"></style>
